export default __webpack_public_path__ + "static/media/lead-abhishek.01ca96c7.png";